import { useContext } from 'react';

import FilesTabContext from '../FilesTabContext';

import FolderTreeList from './FolderTreeList';

import classes from './folderTree.module.css';

const FolderTreeView = () => {
  const { folderTree } = useContext(FilesTabContext);

  if (!folderTree) {
    return <div className={classes.folderTreeContainer} />;
  }

  return (
    <div className={classes.folderTreeContainer}>
      <FolderTreeList trees={[folderTree]} level={0} ancestors={[]} />
    </div>
  );
};

export default FolderTreeView;
